import axios from "axios";
import config from "../config";
import { TokenContext } from "../context/TokenContext";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const afasFetcher = async (input: [string, any, string]) => {
  const [path, queryStringParameters, token] = input;
  return axios
    .get(`${config.BASE_URL_DEV}${path}`, {
      headers: {
        Authorization: token,
      },
      params: queryStringParameters,
    })
    .then((res) => res.data);
};

function useAfasData(
  path: string,
  queryStringObj = {},
  options = {
    enabled: true,
  }
): {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  status: "error" | "success" | "pending";
  isLoading: boolean;
  refetch: (options: { throwOnError: boolean; cancelRefetch: boolean }) => Promise<UseQueryResult>;
  errorMessage: string | undefined;
  statusCode: number;
  errorType: string;
  error: string | undefined;
} {
  const token = useContext(TokenContext);

  // eslint-disable-next-line no-unused-vars
  const { data, error, isLoading, status, refetch } = useQuery({
    queryKey: [path, queryStringObj, token],
    queryFn: () => afasFetcher([path, queryStringObj, token]),
    enabled: options.enabled && !!token,
  });

  let errorMessage;
  let errorType = "";
  let statusCode = 200;

  if (error) {
    errorType = "UnexpectedError";
    statusCode = 400;
    errorMessage = `ERROR ${error.message}`;
  }
  return {
    data,
    status,
    isLoading,
    refetch,
    errorMessage,
    statusCode,
    errorType,
    error: errorMessage,
  };
}

export default useAfasData;
